import { useEffect, useState, useCallback } from 'react'
import { Link } from "react-router-dom";
import Menu from './Menu';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const handleToggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <header className={`header-area ${isSticky ? 'stick' : ''}`}>
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-3 col-md-3 col-4">
              <div className="logo">
                <Link to={"/"}><img src="/image/logo.webp" alt="Logo" /></Link>
              </div>
            </div>

            <div className="col-lg-9 col-md-9 col-8">
              <div className="right-menu">
                  <span>Menu</span>
                  <div className="menu-toogle" onClick={handleToggleMenu}>
                    <div className="menu-line icon-top"></div>
                    <div className="menu-line icon-center"></div>
                    <div className="menu-line icon-bottom"></div>
                  </div>
              </div>
            </div>

          </div>
        </div>
      </header>

      <Menu isOpen={isOpen} setIsOpen={setIsOpen}/>
    </>
  )
}
